module.exports = __webpack_public_path__ + "img/horizontal_6_4_pp1_8011.abd3a776.png";